module.exports = __webpack_public_path__ + "static/media/ic_iterate.25df2ef1.svg";